import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(6),
        boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.06)',
        borderRadius: theme.spacing(2)
    },
    buttonPrimary: {
        background: theme.palette.trade.button,
        textTransform: "capitalize",
        height: 35,
        borderColor: theme.palette.Primary.background,
        marginRight: 15,
        fontWeight: 400,
        color: theme.palette.background.white,
        "&:hover": {
          backgroundColor: theme.palette.trade.header,
          borderColor: theme.palette.trade.header,
          color: theme.palette.Primary.light,
          },
    },
    buttonSecondary:{
        background: theme.palette.background.white,
        textTransform: "capitalize",
        height: 35,
        borderColor: theme.palette.trade.button,
        marginRight: 15,
        fontWeight: 500,
        color: theme.palette.trade.button,
        "&:hover": {
          backgroundColor: theme.palette.trade.header,
          borderColor: theme.palette.trade.header,
          color: theme.palette.Primary.light,
          },
    }

}));

export default useStyles;
